
import React, { Component } from 'react'
// import {Modal,Alert,Button,ButtonToolbar} from 'react-bootstrap'
// import FontAwesome from 'react-fontawesome'
import onClickOutside from 'react-onclickoutside'
import MessagePopup from './MessagePopup'
import MessageNoti from './MessageNoti'
import MessageStore from '../../stores/MessageStore'
/* 
2. Pop up all messages window
  - column :"เวลาส่ง", "ผู้ส่ง","ข้อความ","ลบ"
  - pager
*/
const MAX_MESSAGE_DISPLAY = 2
class MessageMenu extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      showModal: false,
      iconClicked: false,
      messageCount:0,
      messages: [],
      channelList:[]
    }
  }

  componentDidMount() {
    this.loadStatMessage()
  }

  loadStatMessage(){
    MessageStore.loadStatMessage((result) => {
      
      this.setState({messageCount:result.unread_count*1,channelList:result.channel_list})
    })
  }

  loadMessage() {
    MessageStore.loadAllMessage((result) => {
      let messages = result.data

      this.setState({messages:messages})
    })
  }

  onMessageClick(messageToRemove, e) {
    // for prototype purposes, this should call backend in production
    this.setState({
      messages: this.state.messages.filter((message) => message.id !== messageToRemove.id)
    })

  }

  renderMenuItem() {
    const MAX_CONTENT_LEN = 15
    return (
      this.state.messages.filter(
        (item, index) => index + 1 <= MAX_MESSAGE_DISPLAY
      ).map((item, index) => (
        <li key={index}>
          <a href="#" onClick={this.onMessageClick.bind(this, item)}>
            <div className="pull-left">
              <img
                src="./img/bigfix-logo-128.png"
                className="img-circle" alt="User Image"
              />
            </div>
            <h4>
              {
                item.content === null ? ''
                : item.content.length < MAX_CONTENT_LEN ? item.content
                : item.content.slice(0, MAX_CONTENT_LEN - 1) + '...'  
              }
              <small>
                <i className="fa fa-clock-o"></i>
                {item.date}
              </small>
            </h4>
            <p>Welcome to CK-BIGFIX</p>
          </a>
        </li>
      ))
    )
  }

  onSeeAllMessagesClick() {
    this.setState({
      showModal: true
    })
  }

  renderMenuOpen() {
    const allMessagesLink =
      <li className="footer">
        <a href="#" onClick={this.onSeeAllMessagesClick.bind(this)}>ดูข้อความทั้งหมด</a>
      </li>

    return (
      <ul className="dropdown-menu">
        <li className="header">มี {this.state.messages.length} ข้อความใหม่</li>
        <li>
          <ul className="menu">
            {this.renderMenuItem()}
          </ul>
        </li>
        {this.state.messages.length > MAX_MESSAGE_DISPLAY ? allMessagesLink : ''}
      </ul>
    )
  }

  onInboxClick() {
    this.setState({
      iconClicked: !this.state.iconClicked
    })
  }

  handleClickOutside = evt => {
    this.setState({
      iconClicked: false
    })
  }

  onModalClose() {
    this.setState({
      showModal: false
    })
  }

  onUpdateUnreadCount(unread_count){
    this.setState({messageCount:unread_count})  
  }

  onNewMessage(msg){
    let {messageCount,showModal} = this.state

    this.setState({messageCount:messageCount*1+1})

    if(showModal){
      this.refs.msgPop.reloadData()
    }
  }

  onMarkReadMessage(){
    let {messageCount} = this.state

    this.setState({messageCount:messageCount*1-1})    
  }

  onOpenMessage(){

  }

  renderMessageNoti(){
    let {channelList} = this.state

    if(channelList.length>0){
      return (<MessageNoti 
        channelList={channelList} 
        onNewMessage={this.onNewMessage.bind(this)}
        onOpenMessage={this.onOpenMessage.bind(this)}
        />)
    }else{
      return ('')
    }
  }

  render() {
    let {messageCount} = this.state
    return (
      <ul className="nav navbar-nav">
        <li className="dropdown messages-menu open">
          <a
            href="#"
            className="dropdown-toggle"
            data-toggle="dropdown"
            //onClick={this.onInboxClick.bind(this)}
            onClick={this.onSeeAllMessagesClick.bind(this)}
          >
            <i className="fa fa-envelope-o"></i>
            <span className="label label-danger" style={{display:(messageCount>0?'':'none'),fontSize:'18px'}}>
              {messageCount}
            </span>
          </a>
          {/*this.state.iconClicked ? this.renderMenuOpen() : ''*/}
        </li>
        <MessagePopup     
          ref={'msgPop'}     
          show={this.state.showModal}
          onMarkReadMessage={this.onMarkReadMessage.bind(this)}
          onUpdateUnreadCount={this.onUpdateUnreadCount.bind(this)}
          onHide={this.onModalClose.bind(this)}
        />
        {this.renderMessageNoti()}
      </ul>
    )
  }
}

export default onClickOutside(MessageMenu)



// WEBPACK FOOTER //
// ./src/view/menu/MessageMenu.js